import { Box, Inline, Stack, xcss, Flex } from '@atlaskit/primitives';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';
import React from 'react';

import { DEFAULT_SKELETON_HEIGHT, CARD_WIDTH } from './constants';

const CARD_HEIGHT = 350;
const COVER_IMAGE_SKELETON_BORDER_RADIUS = '6px 6px 0 0';

const galleryContainerStyles = xcss({
  gap: 'space.200',
  marginLeft: 'space.600',
  marginTop: 'space.200',
  height: `${CARD_HEIGHT}px`,
});

const skeletonCardContainerStyles = xcss({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  boxShadow: 'elevation.shadow.raised',
  width: `${CARD_WIDTH}px`,
  backgroundColor: 'elevation.surface',
  borderRadius: token('radius.medium', '6px'),
});

const skeletonCardContentStyles = xcss({
  padding: 'space.200',
  flex: '1',
});

const skeletonCardFieldStyles = xcss({
  paddingTop: 'space.200',
  gap: 'space.075',
});

const footerContainerStyles = xcss({
  marginTop: 'auto',
});

const addEntryStyles = xcss({
  gap: 'space.100',
  justifyContent: 'center',
  alignItems: 'center',
  flex: '1',
});

export const DatabaseGallerySkeleton = () => {
  return (
    <Flex xcss={galleryContainerStyles}>
      <Box xcss={skeletonCardContainerStyles}>
        <Skeleton
          width="100%"
          height="185px"
          borderRadius={COVER_IMAGE_SKELETON_BORDER_RADIUS}
          isShimmering
        />
        <Stack xcss={skeletonCardContentStyles}>
          <Skeleton width="100%" height={DEFAULT_SKELETON_HEIGHT} isShimmering />
          <Stack xcss={skeletonCardFieldStyles}>
            <Skeleton width="78px" height={DEFAULT_SKELETON_HEIGHT} isShimmering />
            <Inline space="space.100">
              <Skeleton width="46px" height={DEFAULT_SKELETON_HEIGHT} isShimmering />
              <Skeleton width="46px" height={DEFAULT_SKELETON_HEIGHT} isShimmering />
              <Skeleton width="46px" height={DEFAULT_SKELETON_HEIGHT} isShimmering />
            </Inline>
          </Stack>
          <Flex
            xcss={footerContainerStyles}
            alignItems="center"
            justifyContent="space-between"
          >
            <Skeleton width="86px" height="10px" isShimmering />
            <Skeleton width="12px" height="12px" isShimmering />
          </Flex>
        </Stack>
      </Box>
      <Box xcss={skeletonCardContainerStyles}>
        <Inline xcss={addEntryStyles}>
          <Skeleton width="16px" height="16px" isShimmering />
          <Skeleton width="80px" height="16px" isShimmering />
        </Inline>
      </Box>
    </Flex>
  );
};
